export interface CalendarLike {
  id: string;
  termStructure?: { name?: string | null } | null;
}

export interface CalendarSessionLike {
  id: string;
  name?: string | null;
  academicCalendars?: ReadonlyArray<CalendarLike> | null;
}

export const UNNAMED_SESSION = 'Unnamed session';
export const UNNAMED_SEMESTER = 'Unnamed semester';
export const UNKNOWN_CALENDAR = 'Unknown calendar';
export const LOADING_CALENDAR = 'Loading…';
export const NO_CALENDAR_PIN = '—';

/** Dropdown label for a session. Never the row id. */
export function sessionOptionLabel(session: Pick<CalendarSessionLike, 'name'>): string {
  return session.name?.trim() || UNNAMED_SESSION;
}

/** Dropdown label for a semester / term calendar inside an already-chosen session. */
export function calendarOptionLabel(calendar: CalendarLike): string {
  return calendar.termStructure?.name?.trim() || UNNAMED_SEMESTER;
}

/**
 * Label for a module's semester pin in a list: "2025/2026 · First Semester".
 *
 * While the sessions are still loading the pin reads "Loading…", and a pin to a
 * calendar that no longer exists reads "Unknown calendar". The calendar id is
 * never shown.
 */
export function calendarPinLabel(
  sessions: ReadonlyArray<CalendarSessionLike>,
  calendarId: string | null | undefined,
  loading = false,
): string {
  if (!calendarId) return NO_CALENDAR_PIN;

  for (const session of sessions) {
    const calendar = session.academicCalendars?.find((c) => c.id === calendarId);
    if (calendar) return `${sessionOptionLabel(session)} · ${calendarOptionLabel(calendar)}`;
  }

  return loading ? LOADING_CALENDAR : UNKNOWN_CALENDAR;
}
